"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArray = void 0;
const react_1 = require("react");
const useArray_1 = __importDefault(require("./array/useArray"));
function useArray(initial) {
    const [value, actions] = useArray_1.default(initial);
    return react_1.useMemo(() => (Object.assign({ value }, actions)), [actions, value]);
}
exports.useArray = useArray;
exports.default = useArray;
//# sourceMappingURL=useArray.js.map